import React from 'react';
import './Select.css';

const Select = ({ label, name, value, onChange, options = [], error, className }) => {
  return (
    <div className="input-container">
      {label && <label className="input-label" htmlFor={name}>{label}</label>}
      <select
        id={name}
        name={name}
        className={`form-control ${className || ''} ${error ? 'error' : ''}`.trim()}
        value={value}
        onChange={onChange}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      {error && <p className="error-message">{error}</p>}
    </div>
  );
};


export default Select;
